import { render } from "./ListMessageAdmin.vue?vue&type=template&id=2d27794a&scoped=true"
import script from "./ListMessageAdmin.vue?vue&type=script&lang=js"
export * from "./ListMessageAdmin.vue?vue&type=script&lang=js"

import "./ListMessageAdmin.vue?vue&type=style&index=0&id=2d27794a&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d27794a"]])

export default __exports__